import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./Form.css";

const Form = ({ btntxt }) => {
    const form = useRef();

    const [formData, setFormData] = useState({
        user_name: "",
        user_email: "",
        user_number: "",
        message: "",
    });

    const [messageSent, setMessageSent] = useState(false);
    const [isSending, setIsSending] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Phone number validation (only 10 digits)
        if (name === "user_number" && value.length > 10) return;

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        setIsSending(true);

        emailjs
            .sendForm(
                "service_xbn2ais",
                "template_sqof43m",
                form.current,
                "827VllvbZnmARtJDd"
            )
            .then(
                () => {
                    console.log("Message sent successfully!");

                    setMessageSent(true);
                    setIsSending(false);

                    // Hide message after 2.5 sec
                    setTimeout(() => {
                        setMessageSent(false);
                    }, 2500);

                    // Clear form
                    setFormData({
                        user_name: "",
                        user_email: "",
                        user_number: "",
                        message: "",
                    });
                },
                (error) => {
                    console.error("Error:", error.text);
                    setIsSending(false);
                }
            );
    };

    return (
        <>
            <h4 className="form-heading">Get in Touch</h4>

            {messageSent ? (
                <div className="form-message">
                    <p>Message sent successfully!</p>
                </div>
            ) : (
                <form className="form" ref={form} onSubmit={handleSubmit}>
                    {/* NAME */}
                    <div className="mb-3">
                        <input
                            value={formData.user_name}
                            name="user_name"
                            type="text"
                            className="form-control"
                            placeholder="Name"
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    {/* PHONE */}
                    <div className="mb-3">
                        <input
                            value={formData.user_number}
                            name="user_number"
                            type="text"
                            className="form-control"
                            placeholder="Phone No."
                            pattern="[0-9]{10}"
                            maxLength="10"
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    {/* EMAIL */}
                    <div className="mb-3">
                        <input
                            value={formData.user_email}
                            name="user_email"
                            type="email"
                            className="form-control"
                            placeholder="Email"
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    {/* MESSAGE */}
                    <div className="mb-3">
                        <textarea
                            value={formData.message}
                            className="form-control"
                            name="message"
                            placeholder="Message"
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    {/* BUTTON */}
                    <button type="submit" className="btn btn-primary" disabled={isSending}>
                        {isSending ? "Sending..." : btntxt || "Submit"}
                    </button>
                </form>
            )}
        </>
    );
};

export default Form;
